module.exports = __webpack_public_path__ + "static/media/bitmoji.3e0246f5.png";